// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2lDfJ","checkboxCol":"Table_checkboxCol__3QLgG","emailCol":"Table_emailCol__27a5z","actionCol":"Table_actionCol__1KgTw"};